import axios from 'axios'
import * as React from 'react'
import { useState } from 'react'

// Shared password overlay for anything gated behind the configurable
// `onsite_remark_password` setting (remark-flagged delegates, badge reprints).
// The password is verified server-side; `onSuccess` runs once it checks out.
const RemarkPasswordModal = ({
  title,
  remark = '',
  cancelLabel = 'Cancel',
  onSuccess,
  onCancel,
}) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [verifying, setVerifying] = useState(false)

  const submit = (e) => {
    e?.preventDefault?.()
    setVerifying(true)
    setError('')
    axios
      .post('/api/users/verify_remark_password', { password })
      .then(({ data }) => {
        // On success the parent unmounts this modal, so don't touch state after.
        if (data?.success) return onSuccess()
        setError('Incorrect password.')
        setVerifying(false)
      })
      .catch(() => {
        setError('Verification failed, please try again.')
        setVerifying(false)
      })
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1060,
      }}
    >
      <div
        className="card p-4"
        style={{ background: '#fff', width: '90%', maxWidth: 460 }}
      >
        <h5 className="mb-3">
          <i className="fas fa-lock me-2"></i>
          {title}
        </h5>
        {remark && (
          <div className="alert alert-warning" style={{ whiteSpace: 'pre-wrap' }}>
            {remark}
          </div>
        )}
        <form onSubmit={submit}>
          <label className="mb-1 d-block fw-bold">
            Enter password to continue
          </label>
          <input
            type="password"
            className="form-control mb-2"
            placeholder="Password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <div className="text-danger mb-2">{error}</div>}
          <div className="d-flex align-items-center">
            <button
              type="submit"
              className="btn btn-sm btn-danger me-2"
              disabled={verifying || !password}
            >
              {verifying ? 'Checking...' : 'Unlock'}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              onClick={onCancel}
            >
              {cancelLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RemarkPasswordModal
